module.exports = __webpack_public_path__ + "img/nisu01.b9d0f573.png";